import type {AgentResponse, AiAgentPendingProposal} from '../../../redux/aiAgent/aiAgent.type';
import type {DraftResult} from '../../aiMessageGenerator/utils/types';

export function isProposalReadyToConfirm(
    pendingProposal?: AiAgentPendingProposal | null,
    flowComplete?: boolean,
): pendingProposal is AiAgentPendingProposal {
    if(!pendingProposal) {
        return false;
    }
    return flowComplete === true || pendingProposal.flowComplete === true;
}

/**
 * The turn carries the summary the agent asks to confirm, and nothing else is being asked.
 * It creates nothing on its own: the producer still has to answer the question, so the
 * proposal is only held. A pendingProposal without flowComplete stays in conversation.
 */
export function isConfirmTurn(
    payload: Pick<AgentResponse, 'ask' | 'pendingProposal' | 'flowComplete'>,
): boolean {
    return isProposalReadyToConfirm(payload.pendingProposal, payload.flowComplete) && !payload.ask;
}

export function buildAgentTurnResult(
    payload: Pick<AgentResponse, 'text' | 'ask' | 'pendingProposal' | 'flowComplete'>,
): {result: DraftResult; readyToConfirm: boolean} {
    return {
        readyToConfirm: isConfirmTurn(payload),
        result: {
            text: payload.text || '',
            ...(payload.ask ? {ask: payload.ask} : {}),
        },
    };
}
